export default function Template(props) {
    return <div className="NotificationTitle">Очищено історію</div>
}
